import { capitalizeFirstLetter } from './commonUtil';

const getEventConfigIntervalKeyName = (consumer, level) => {
  const key = `${consumer}${capitalizeFirstLetter(level)}Sync`;
  return key;
};

export default getEventConfigIntervalKeyName;
